import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ClientList from '../components/client-list-view';
import { useNavigate } from 'react-router-dom';
import { uiShowToastrMessage } from 'modules/ui-module';
import resolveRoute from 'lib/resolve-route';
import {
  clientList,
  clientsIsLoading,
  clientListRequestGet,
  clientIsAdmin,
  clientAdminRequestSearchGet,
} from 'modules/portal-module';
import {
  setHandledErrorCodes,
  removeHandledErrorCodes
} from 'lib/error-message-handling';
import { meId, meUserName } from 'modules/me-module';
import {
  stopEvent
} from 'lib/utility-functions';
import castleIOWrapper from 'lib/castleio-tracking';
import { meLocale } from "modules/me-module";
import { isInternalDevEmail } from 'lib/user-type';

const getErrorCodesArray = () => {
  return [
    404,
    'client.not.found',
  ];
};


export const ClientListContainer = (props) => {
  const [searchValue, setSearchValue] = useState('');
  const [error, setError] = useState({ name: '', showError: false });
  const [clientsIsLoading, setClientIsLoading] = useState(true);

  const [loading, setLoading] = useState(true);
  const [clientExist, setClientExist] = useState(false);
  const [ctaClicked, setCtaClicked] = useState(false);

  const externalProps = useSelector(getValuesFromStore);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setClientIsLoading(true);
    if (castleIOWrapper && castleIOWrapper.identifyUserAndTrackPageInCastle) {
      castleIOWrapper.identifyUserAndTrackPageInCastle(externalProps.meId, externalProps.meUserName, 'Client Management Portal - Clients');
    }
    Promise.all([dispatch(clientListRequestGet())]).then(() => {
      setClientIsLoading(false);
    });
  }, [dispatch, externalProps.meId, externalProps.meUserName]);

  const onChange = (e) => {
    setError({ error: {} });
    const clientId = e.target.value;
    stopEvent(e);
    setSearchValue(clientId);
    setCtaClicked(false);
  };

  const searchClient = (e) => {
      setError({});
      setLoading(true);
      stopEvent(e);
      //check if client is valid or not
      const clientIsValid = searchValue.trim().length !== 0;
      if (clientIsValid) {
        setHandledErrorCodes(getErrorCodesArray());
        dispatch(clientAdminRequestSearchGet(searchValue.trim()))
          .then(
            (result) => {
              setClientExist(true);
              removeHandledErrorCodes(getErrorCodesArray());
              navigate(resolveRoute('clients.clientedit', {routeParams: [result.payload?.clientId]}));
              setLoading(false);
            },
            (ex) => {
              setClientExist(false);
              setCtaClicked(true);
              removeHandledErrorCodes(getErrorCodesArray());
              dispatch(uiShowToastrMessage('error', 'client-info.client-not-found', null));
              setLoading(false);
            }
          );
      }
      else {
        setError({ name: 'shared.client-id.validation.error'});
        setLoading(false);
      }
    };


  const onSearch = () => {
    //check if client is valid or not
    const clientIsValid = searchValue.trim().length !== 0;
    if (!clientIsValid)
      setError({ name: 'shared.client-id.validation.error', showError: true });
    else
      searchClient();
  };

  return (
    <ClientList
      clientList={externalProps.clientList}
      hasClients={!!externalProps.clientList && !!externalProps.clientList.length && !clientsIsLoading}
      isLoading={externalProps.isLoading && clientsIsLoading}
      showClientIdSearchInput={externalProps.clientIsAdmin && externalProps.clientIsAdmin}
      onChange={onChange}
      searchValue={searchValue}
      onSearch={onSearch}
      error={error}
      clientExist={clientExist}
      ctaClicked={ctaClicked}
      searchLoading={loading}
      isInternalDev={externalProps.isInternalDev}
    />
  );
};

export const getValuesFromStore = (state) => {
  return {
    meId: meId(state) || '',
    meUserName: meUserName(state) || '',
    clientList: clientList(state) || [],
    isLoading: clientsIsLoading(state) || true,
    clientIsAdmin: clientIsAdmin(state) || false,
    meLocale: meLocale(state),
    isInternalDev: isInternalDevEmail(meUserName(state) || ''),
  };
};

export default ClientListContainer;
